export default __webpack_public_path__ + "static/media/Intimation on closure of Trading Window.160cf6e4.pdf";